export const liveBigScreen = {
  namespaced: true,

  state: () => ({
    currentLot: {
      auctionTitle: "",
      auctionLocation: "",
      auctionCoverImageUrl: "",
      scheduledCount: null,
      remainingCount: null,
      lastStatus: null,
      lastStatusText: null,
      lastHammerPrice: null,
      lotNumber: "",
      title: "",
      subTitle: "",
      artistName: "",
      coverImageUrl: "",
      status: null,
      statusText: "",
      currentBid: null,
      currentBidUSD: null,
      currentBidHKD: null,
      currentBidEUR: null
    },

    auctionInfo: {
      name: "2024春季艺术品拍卖会",
      totalLots: 120,
      currentLot: 45
    },

    subscribed: false,
    auctionId: null
  }),

  mutations: {
    SET_CURRENT_LOT(state, data) {
      state.currentLot = { ...state.currentLot, ...data }
    },

    UPDATE_CURRENT_LOT(state, data) {
      // 只更新部分字段
      Object.assign(state.currentLot, data)
    },

    SET_AUCTION_INFO(state, data) {
      Object.assign(state.auctionInfo, data)
    },

    SET_SUBSCRIBED(state, status) {
      state.subscribed = status
    },

    SET_AUCTION_ID(state, id) {
      state.auctionId = id
    },

    //更新拍品
    REPLACE_CURRENT_LOT(state, newLotData) {
      state.currentLot = { ...newLotData }
    },
  },

  actions: {
    async subscribe({ commit, dispatch, rootState }, { auctionId, token }) {
      console.log("=== liveBigScreen/subscribe 开始 ===" + token)
      console.log("auctionId:", auctionId)
      console.log(
        "rootState.websocket?.connection:",
        rootState.websocket?.connection
      )

      commit("SET_AUCTION_ID", auctionId)

      console.log("准备调用 websocket/send")

      const success = await dispatch(
        "websocket/send",
        {
          action: "subscribe",
          payload: {
            messageId: `sub_${Date.now()}`,
            data: {
              channel: "board",
              auctionId: auctionId,
              token: token
            }
          }
        },
        { root: true }
      ).catch(err => {
        console.log("websocket/send 错误:", err)
      })

      if (success) {
        commit("SET_SUBSCRIBED", true)
        console.log("订阅消息已发送")
      }

      return success
    },

    unsubscribeAuction({ commit, state, dispatch }, { auctionId, token }) {
      if (state.auctionId) {
        dispatch(
          "websocket/send",
          {
            action: "unsubscribe",
            payload: {
              channel: "board",
              auctionId: auctionId,
              token: token
            }
          }
        )

        commit("SET_SUBSCRIBED", false)
        commit("SET_AUCTION_ID", null)
      }
    },

    // 处理接收到的拍品更新
    handleLotUpdate({ commit }, data) {
      console.log("收到拍品更新:", data)

      // 根据消息类型更新不同的数据
      if (data.type === "lot_update" || data.event === "lot_update") {
        // 更新当前拍品
        commit("UPDATE_CURRENT_LOT", data.payload || data)
      } else if (
        data.type === "auction_info" ||
        data.event === "auction_info"
      ) {
        // 更新拍卖会信息
        commit("SET_AUCTION_INFO", data.payload || data)
      } else if (data.type === "bid_update" || data.event === "bid_update") {
        // 只更新出价相关字段
        commit("UPDATE_CURRENT_LOT", {
          currentBid: data.payload?.currentBid || data.currentBid,
          currentBidUSD: data.payload?.currentBidUSD || data.currentBidUSD,
          currentBidHKD: data.payload?.currentBidHKD || data.currentBidHKD,
          currentBidEUR: data.payload?.currentBidEUR || data.currentBidEUR
        })
      }
    },

    updateCurrentLotCompletely({ commit }, newLotData) {
      console.log('updateCurrentLotCompletely', newLotData)
      commit("REPLACE_CURRENT_LOT", newLotData.data)
      commit("SET_AUCTION_ID", newLotData.auctionId) // auctionId变化时，触发在响应页面的刷新
    },

    // 重置状态
    reset({ commit }) {
      commit("SET_CURRENT_LOT", {})
      commit("SET_AUCTION_INFO", {
        name: "2024春季艺术品拍卖会",
        totalLots: 120,
        currentLot: 45
      })
      commit("SET_SUBSCRIBED", false)
      commit("SET_AUCTION_ID", null)
    }
  },

  getters: {
    currentLot: state => state.currentLot,
    auctionInfo: state => state.auctionInfo,
    isSubscribed: state => state.subscribed
  }
}
